import { utils } from '@costar/theme-ui';
import React from 'react';
import renderGroupOptions from './render-group-options.esm.js';

function renderOptions(options, renderItem, selection) {
  var selectionClick = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (_v) {
    return utils.noop;
  };
  var handleClose = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : utils.noop;
  var extendedContent = arguments.length > 5 ? arguments[5] : undefined;
  var extendedContentTop = arguments.length > 6 ? arguments[6] : undefined;
  var groupKey = arguments.length > 7 ? arguments[7] : undefined;
  return /*#__PURE__*/React.createElement(React.Fragment, null, extendedContentTop, Array.isArray(options) ? options.map(renderItem(selectionClick, handleClose, selection)) : utils.isNotEmptyObject(options) ? options ? renderGroupOptions(options, renderItem, selectionClick, handleClose, selection, groupKey) : null : null, extendedContent);
}

export default renderOptions;
//# sourceMappingURL=render-options.esm.js.map
